import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconReload$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconReload extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '861491b8206c3b69d0bfa203fdc4471feb5b56a2', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1d6017a037b8d3f9d656e8ad374f0733bcbec33c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9902cf387dd573332c93e0c293d90b5c18064d55', d: "M5.904 15.596a6.5 6.5 0 0 0 8.825.34.53.53 0 0 1 .72.014l.354.353a.477.477 0 0 1-.01.697 8 8 0 1 1 .364-11.657l1.638 1.638 1.555-1.55a.4.4 0 0 1 .686.276v4.242a.4.4 0 0 1-.396.396h-4.243a.4.4 0 0 1-.283-.693l1.618-1.612-1.636-1.636a6.5 6.5 0 1 0-9.192 9.192", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-reload", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-reload"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-reload":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconReload$1);
            }
            break;
    } });
}

const CosmosIconReload = CosmosIconReload$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconReload, defineCustomElement };
